import React, {useState,useEffect} from 'react';
import {Link,NavLink} from 'react-router-dom';
import {ResGet,url} from './component/resapi'
import HeaderTwo from './HeaderTwo'
import noImage from './asset/image/no-image-icon.png';
import imagesLoead from './component/utility/imageLoad'
import Div100vh from 'react-div-100vh'
import {connect} from 'react-redux';
import {isLoading} from "./redux/actions"

function Archive(props) {
  const [isActiveFilter,setIsActiveFilter] = useState(false)
  const [Alldata, setAlldata] = useState([])
  const [loading, setloading] = useState(true)
  const [skipLimit,setSkipLimit] =  useState(0)
  const [loadingScroll, setloadingScroll] = useState(false)
  useEffect( ()=>{
    props.isLoading(false)
    ResGet(`getarchive/all/0`).then(async(response)=>{
      if(response.status===200){
        await setAlldata(response.data)
        await setloading(false)
        setTimeout(() => {
          imagesLoead(()=>{
            props.isLoading(true)
          })
        }, 1100);
      }
    })
  },[]);

  useEffect(() => {
    const scrollTarget = document.querySelector(".container")
    function handleReg(){
      if((scrollTarget.scrollTop + scrollTarget.clientHeight) === scrollTarget.scrollHeight){
        if(!loadingScroll){
          setloadingScroll(true)
          ResGet(`getarchive/all/${skipLimit+20}`).then(async(response)=>{
            if(response.status===200 && response.data.length>0){
              await setAlldata(value=>[...value,...response.data])
              await setSkipLimit(value=> value+20)
              await setloadingScroll(false)
            }
          })
          }
    }
    }
    scrollTarget.addEventListener("scroll", handleReg)
    return ()=>{
      scrollTarget.removeEventListener("scroll", handleReg)
    }
  }, [skipLimit,loadingScroll])

   return (
    <Div100vh style={{height:"100rvh",overflow:"hidden"}}>
     <HeaderTwo w={true} active={isActiveFilter} close={()=>setIsActiveFilter(false)}>
        <Filter onSetData={setAlldata}/>
     </HeaderTwo>
     <div className="bg-fixed-light">
        <div className="container-main">
          <div className="container">
            <div className="header">
              <NavLink to="/" className="clickable">home</NavLink>
              <NavLink to="/archive" className="clickable">archive</NavLink>
            </div>
            <div className="ltr" style={{marginTop:"0.6232em"}}>
            <div className="row">
            {!loading?
            Alldata.map((data,key)=>
              <div className="col-lg-3 col-md-6 col-12 mb-1" key={key}>
              <div className="post clickable">
              <div className="image">
                  <Link to={{
                        pathname: `/archive/${data.name.split(" ").join("-")}`,
                        state: { id: data.id }
                        }} ><img src={data.preview?`${url+"/"+data.preview}`:noImage} alt={data.name}/></Link>
              </div>
              <div className="text">
              <Link to={{
                        pathname: `/archive/${data.name.split(" ").join("-")}`,
                        state: { id: data.id }
                        }} className="clickable"><h4>{data.name}</h4></Link>
              <Link to={{
                        pathname: `/archive/${data.name.split(" ").join("-")}`,
                        state: { id: data.id }
                        }} className="clickable"><p>{data.html}</p></Link>
              </div>
              </div>
            </div>
            ):""}

              <div className="filter clickable" onClick={()=>setIsActiveFilter(true)}>
                <span><i className="icon icon-filter" ></i> <span>FILTER</span></span>
              </div>
            
            </div>
            </div>
          </div>
        </div>
    </div>
    </Div100vh>
  );
}

const Filter =(props)=>{
  const [list, setlist] = useState([])
  const [defaultFilter, setdefaultFilter] = useState("All")
  useEffect(() => {
    ResGet("getfilterarchive").then((response)=>{
      if(response.status===200){
        setlist(response.data)
      }
    })
  }, [])
  const handelFilter =(value)=>{
    ResGet(`search/archive/${value}/0`).then(response=>{
      if(response.status===200){
        setdefaultFilter(value)
        props.onSetData(response.data)
        props.onClose()
      }
    })
  }
  const handelNotFilter =()=>{
    ResGet(`getarchive/all/0`).then(async(response)=>{
      if(response.status===200){
        setdefaultFilter("All")
        props.onSetData(response.data)
        props.onClose()
      }
    },[])
  }
  return(
        <div className="content filter-main">
        <div className="box" style={{flex:"0 0 auto"}}>
            <ul>
              <li className={defaultFilter==="All"?"active":""}><span className="hoverline clickable" onClick={handelNotFilter}>All</span></li>
              {list.map((data,key)=>
                <li key={key} className={defaultFilter===data?"active":""}><span className="hoverline clickable" onClick={()=>handelFilter(data)}>{data}</span></li>
              )}
            </ul>
        </div>
        </div>
  )
}
export default connect(null,{isLoading})(Archive);
